import React from 'react';
import './box-cta.styles.scss';

import { Link } from 'react-router-dom';

function BoxCta({
  title,
  className,
  smallBoxCta,
  subTitle,
  content,
  link,
  color,
  categories,
  transparent,
  test,
  isFromSoftware,
}) {
  return (
    <Link
      className={`
                ${className || ''}
                box-cta-full-height
                box-cta box-background xs-only-trinity-container
                ${transparent ? 'transparent' : ''} 
                ${categories ? categories[0].id : ''}
                ${smallBoxCta ? 'small-box-cta' : ''}
               ${color}
            `}
      to={link}
    >
      {title && (
        <div className="title">
          <div dangerouslySetInnerHTML={{ __html: title }} />{' '}
          {/* NL # TASK 40 */}
          {smallBoxCta && <span className="arrow d-none d-sm-inline">›</span>}
        </div>
      )}
      {subTitle && <div className="sub-title">{subTitle}</div>}
      {content && isFromSoftware ? (
        <div className="custom-block">{content}</div>
      ) : (
        <div
          className="content"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      )}
      {link ? (
        <div className="bottom-link">
          <span className="link-text">
            Learn More <span className="arrow">›</span>
          </span>
        </div>
      ) : (
        ''
      )}
    </Link>
  );
}

export default BoxCta;
